// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OOtDX","newExpiryDate":"styles_newExpiryDate__fggms","footer":"styles_footer__3CKcB"};